export default __webpack_public_path__ + "static/media/home-banner3.9b250776.png";